import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsersBetweenLines } from "@fortawesome/free-solid-svg-icons";
import "../CaseDetails/CaseDetails.css";
import { useState  } from "react";
import { useNavigate } from "react-router-dom";
import TableComponent from "../../components/TableComponent";


function AssociationMembersReport(params) {

    const columns = [
        { name: "رقم العضو", key: "membership_serial" },
        { name: "اسم العضو", key: "name" },
        { name: "نوع العضوية", key: "status" },
        { name: "تاريخ العضوية", key: "start_membership_date" },
        { name: "تاريخ الإشتراك", key: "start_subscription_date" },
        { name: "", key: "actions" },
    ];


    const [rows, setRows] = useState([]);
  


   

    const dropdownOptions = [
        { label: "تعديل", route: "/showAssociationMembers/:id" },
        { label: "سند قبض", route: "/associationMemberspayment/:id" },
        { label: "سند دفع", route: "/associationMembersRecieve/:id" },
    ];

    

    const transferType = (type) => {
        if (type == 1) return "داعمة";
        if (type == 2) return "فخرية";
        if (type == 3) return "عادية";
    }


    const handleDownload = (selectedRows) => {
        const selectedData = rows.filter((row) => selectedRows.includes(row.id));
        if (selectedData.length === 0) {
            alert("Please select at least one row.");
            return;
        }

        const csvHeader = columns
            .filter((col) => col.key !== "actions")
            .map((col) => col.name)
            .join(",");

        const csvRows = selectedData.map((row) =>
            columns
                .filter((col) => col.key !== "actions")
                .map((col) => `"${row[col.key] || ""}"`)
                .join(",")
        );

        const csvContent = `${csvHeader}\n${csvRows.join("\n")}`;

        const bom = "\uFEFF";
        const finalContent = bom + csvContent;

        const blob = new Blob([finalContent], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", "selected_rows_report.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const modifyRow = (row) => {
        let modifiedRow = { ...row };
        modifiedRow.status = modifiedRow.status === 1 ? "عضو مجلس ادارة" : " عضو جمعية عمومية";
        return modifiedRow;
    };

    return (
        <>
            <div className="printcasedata-container">

                
                <TableComponent
                    apiUrl="/assemblymembers"
                    columns={columns}
                    title="تقرير الأعضاء"
                    titleIcon={<FontAwesomeIcon icon={faUsersBetweenLines} />}
                    dropdownOptions={dropdownOptions}
                    transformRowFn={modifyRow}
                
                />
            </div>
        </>
    );
}
export default AssociationMembersReport
